import React, { useRef, useCallback, useState, useEffect } from 'react';

import './Row.css'
import NormalComponentContainer from './NormalComponentContainer';
import DnDOverContent from '../common/DnDOverContent'
import { allowed_types_component_menu, allowed_types_component, allowed_types_component_with_indepth } from './DropContext';
import ComponentDropArea, { renderComponentDropArea, RenderComponentDropArea } from '../ComponentDropArea';
import SpecialComponentContainer from './SpecialComponentContainer';
import GroupSlider from './GroupSlider';
import Group from './Group';
import DnDContext from '../DnDContext';
import { DragHandle } from '../common/Common_styles';
import { DnD_element_type_category, DnD_element_type, DnD_element_type_menu } from '../common/ConstantValues';
import DraggableComponent from './DraggableComponent';
import classnames from 'classnames'
import { getType, translateLayout } from '../common/MyUtils';
import SliderViewContainer from './SliderViewContainer';
import { getWording } from '../Wording';

const Row = (props) => {
  const { 
    layout, 
    attr, 
    col, 
    components, 
    fillRemainCol, 
    row_index, 
    editingRowIndex,
    editing_slide_page_index, 
    message_index, 
    isDragging, 
    showOptions, 
    editing, 
    editingThis,
    // editingIndexes,
    messageActions,
    currentEditMessage,
    currentEditSlidePage,
  } = props
  const { 
    onDrop, 
    onTopComponentDrop, 
    setIndexForSlidePage, 
    updateRow, 
    onCopy 
  } = props
  
  const layoutDialogRef = useRef()
  const [ renderedHeight, setRenderedHeight ] = useState(null)
  const [ _showOptions, setShowOptions ] = useState(showOptions ? showOptions : false)
  const depthComponentFlag = editingRowIndex || editingRowIndex === 0
  const depthComponentRef = useCallback((node) => {
    if (node) {
      // Wait for complete rendering
      setTimeout(() => {
        setRenderedHeight(node.offsetHeight) 
      }, 250)
    }
  }, [])

  // const depthComponentRef = useRef()
  // Component menu onDrop
  const onComponentDrop_menu = (e) => {
    const { component_index } = e
    onDrop({
      ...e,
      component_index: component_index || component_index === 0 ? component_index : 0,
      editing_row_index: editingRowIndex,
    })
  }

  /**
   * Row의 제일 Top 고정 Drop area에 Component가 Drop될 시 Container로 넘김
   * @param {Object} e 
   */
  const onComponentDrop = (e) => {
    onTopComponentDrop(e)
  }
  
  /**
   * Add same type component 버튼 onClick handler
   */
  const onClickAddBtn = (e) => {
    const type_info = getType(attr)
    onComponentDrop_menu({
      type: '_' + type_info.type,
      prefix_type: type_info.prefix,
      cat_type: "MENU",
      component_index: components.length,
      editing_row_index: editingRowIndex,
    })
//     type: "_BUTTON"
// prefix_type: "NORMAL"
// cat_type: "MENU"
// component_index: 3
// editing_row_index: null
  }

  const render_Components = (layout, attr, col, components, fillRemainCol, onDrop) => {
    const { dragStart, dragEnd } = props 
    const typeInspectResult = isNormalComponent(attr)
    /**
     * Group component rendering
     * No components.map process
     */
    if (typeInspectResult.type === 'GROUP') {
      return (
        <div ref={depthComponentRef}>
          <DraggableComponentWrap
            messageIndex={message_index}
            rowIndex={row_index}
            rowIndexDetail={editingRowIndex}
            // componentIndex={0}
            handleWrapCSS={{paddingTop: 5, paddingBottom: 5,}}
            contentWrapCSS={{padding: 0}}
            renderedHeight={renderedHeight}
            onDragStart={dragStart} 
            onDragEnd={dragEnd} 
            cat_type={DnD_element_type_category.REN_ELEM}
            disable={!editing ? undefined : editing}
            type={DnD_element_type.COMPONENT.NORMAL.GROUP} prefix_type="NORMAL">
            <Group 
              layout={layout}
              components={components}
              message_index={message_index}
              row_index={row_index}
              setIndex={setIndexForSlidePage}
              type={typeInspectResult}
              disable={editing && !editingThis}
              onCopy={onCopy}
              // editingIndexes={editingIndexes}
              editing_message_index= {props.editing_message_index}
              editing_row_index= {props.editing_row_index}
              editing_slide_page_index= {editing_slide_page_index}
              messageActions={messageActions}
              currentEditSlidePage={currentEditSlidePage}
              isDragging={isDragging}
            />
          </DraggableComponentWrap>
        </div>
      )
    }

    if (layout !== "default") {
      return render_Components_layout(typeInspectResult, components, layout, onDrop)
    }

    if (col > 1) {
      return render_Components_grid(typeInspectResult, components, col, fillRemainCol, onDrop)
    }

    return render_Components_basic(typeInspectResult, components, onDrop)
  }

  const render_Components_basic = (typeInspectResult, components, onDrop) => {
    /**
     * 컴포넌트 dragging 시 Change index position 할 수 있는 drop area를 랜더링 합니다.
     */
    let render_result = [(
      isDragging ? (
        /* Drop area for Change component index position function */
        <RenderComponentDropArea
          key={"top_drop_index_position"}
          onDrop={onComponentDrop}
          DnDOverContent={DnDOverContent}
          overContentArg={overContentArg}
          allowed_types={depthComponentFlag ? allowed_types_component_with_indepth : allowed_types_component} // Allow all-types
          // allowed_types={[typeInspectResult.type]} // Allow row.attr component type
        />
      ) : (
        /* Drop area for Add component function */
        <RenderComponentDropArea
          key={"top_drop_add_component"}
          onDrop={onDrop}
          DnDOverContent={DnDOverContent}
          overContentArg={overContentArg}
          allowed_types={allowed_types_component_menu}
        />
      )
    )]

    // let render_result = [renderComponentDropArea(onDrop, DnDOverContent, overContentArg, allowed_types_component_menu)]
    render_result = render_result.concat(components.map((component, i) => {
      const { local_id } = component
      if (typeInspectResult.result) {
        return (
          <NormalComponentContainer {...component} 
            key={i}
            index={i}
            onDrop={onDrop}
            message_index={message_index}
            row_index={row_index}
            editing_row_index={editingRowIndex}
            editing_slide_page_index={editing_slide_page_index}
            isDragging={isDragging}
            inDepth={editingRowIndex || editingRowIndex === 0}
            component_index={i+1}
            attr={typeInspectResult.type}
            col={col}
            disable={editing && !editingThis}
            messageActions={messageActions}
          />
        )
      }
      return (
        <SpecialComponentContainer {...component}
          key={i}
          index={i}
          onDrop={onDrop}
          message_index={message_index}
          row_index={row_index}
          editing_row_index={editingRowIndex}
          component_index={i+1}
          attr={typeInspectResult.type}
          disable={editing && !editingThis}
          messageActions={messageActions}
        />
      )
    }))

    return render_result
  }

  const render_Components_layout = (typeInspectResult, components, layout) => {
    const { dragStart, dragEnd } = props 
    return ( 
      <div ref={depthComponentRef}>
        <DraggableComponentWrap
          messageIndex={message_index}
          rowIndex={row_index}
          rowIndexDetail={editingRowIndex}
          // componentIndex={0}
          handleWrapCSS={{paddingTop: 5, paddingBottom: 5,}}
          contentWrapCSS={{padding: 0}}
          renderedHeight={renderedHeight}
          onDragStart={dragStart} 
          onDragEnd={dragEnd} 
          cat_type={DnD_element_type_category.REN_ELEM}
          type={DnD_element_type.COMPONENT.NORMAL.GROUP} prefix_type="NORMAL">
          <SliderViewContainer 
            layout={layout}
            components={components}
            attr={attr}
            type={typeInspectResult}
            message_index={message_index}
            row_index={row_index}
            isMultiRow={false}
            noDropArea={true}
            renderType={'slide'}
            // setIndex={(e) => {console.log('e :', e)}}
            col={col}
            editing_message_index= {props.editing_message_index}
            editing_row_index= {props.editing_row_index}
            editing_slide_page_index= {props.editing_slide_page_index}
            messageActions={messageActions}
            currentEditSlidePage={currentEditSlidePage}
          />
        </DraggableComponentWrap>
      </div>
    )
  }

  const render_Components_grid = (typeInspectResult, components, col, fillRemainCol, onDrop) => {
    const width_percent = Math.floor(100 / col)
    // 컴포넌트 타입에 따른 첫 번째 Drop area height 값을 부여함
    const firstDropAreaHeight = typeInspectResult.type === (
      DnD_element_type.COMPONENT.NORMAL.BUTTON.inDepth || typeInspectResult.type === DnD_element_type.COMPONENT.NORMAL.IMAGE.outDepth) ? 
      35 : 
      (typeInspectResult.type === DnD_element_type.COMPONENT.NORMAL.IMAGE.inDepth || typeInspectResult.type === DnD_element_type.COMPONENT.NORMAL.IMAGE.outDepth) ? 
        224 : 
      35
    /**
     * 컴포넌트 dragging 시 Change index position 할 수 있는 drop area를 랜더링 합니다.
     */
    let render_result = [(
      isDragging ? (
        /* Drop area for Change component index position function */
        <RenderComponentDropArea
          key={"top_drop_index_position"}
          onDrop={onComponentDrop}
          DnDOverContent={DnDOverContent}
          overContentArg={{...overContentArg_grid, minHeight: firstDropAreaHeight ? firstDropAreaHeight : overContentArg_grid.minHeight}}
          allowed_types={depthComponentFlag ? allowed_types_component_with_indepth : allowed_types_component}
          // allowed_types={[typeInspectResult.type]} // Allow row.attr component type
          customStyle={{display: 'inline-block', minWidth: 20, minHeight: firstDropAreaHeight, verticalAlign: 'top', opacity: 0.3,}}/>
      ) : (
        /* Drop area for Add component function */
        <RenderComponentDropArea
          key={"top_drop_add_component"}
          onDrop={onDrop}
          DnDOverContent={DnDOverContent}
          overContentArg={overContentArg_grid}
          allowed_types={allowed_types_component_menu}
          customStyle={{display: 'inline-block', minWidth: 20, minHeight: firstDropAreaHeight, verticalAlign: 'top', opacity: 0.3,}}/>
      )
    )]

    // Row의 component를 column으로 나눈 나머지 값
    const remainValue = components.length % col
    // Default minus value
    const defaultMinValue = ((col) => {
      switch(col) {
        case 3:
          return 7
        case 2:
          return 10
        case 1: 
          return 7
        default:
          return 0
      }
    })(col)

    // 남은 column
    const remainColumns = col - (remainValue !== col && remainValue !== 0 ? remainValue : col)
    // 'add-btn'은 추가 버튼을 component map 컨텍스트에서 같이 생성하기 위해 임시 요소로 추가하였음 (Width 값 계산)
    render_result = render_result.concat(components.map((component, i, _components) => {
    // render_result = render_result.concat(components.concat(['add-btn']).map((component, i, _components) => {
      const { local_id } = component
      // 첫번째 Row flag
      const firstRowFlag = i < col
      // Pre-component drop area flag
      const preDropAreaFlag = i % col === 0 && i !== 0 && i+1 > col
      // fillRemainCol을 적용하는 조건
      const fillRemainColFlag = i+1 === _components.length && fillRemainCol
      // const fillRemainColFlag = i+2 === _components.length && fillRemainCol
      // 조절값
      const calcMinForWidthValue = !firstRowFlag && preDropAreaFlag && !fillRemainColFlag ? 20 : 0
      // minus 7px by columns for fillRemainCol last column
      /**
       * note : component 1개에 col 3일경우 21px만큼 제외하는데 불필요하게 제외하여 col 3에 대한 컨디션?
       */
      const minValueByColCount = fillRemainColFlag ? components.length % col !== 0 ? (col * 7) : 0 : 0 
      // const minValueByColCount = fillRemainColFlag ? (remainColumns * 7) : 0
      // 
      const calc_width_percent = fillRemainColFlag ? width_percent + width_percent * remainColumns : width_percent
      
      const componentWrapStyle = {display: 'inline-block', width: `calc(${calc_width_percent}% - ${defaultMinValue}px + ${calcMinForWidthValue}px - ${minValueByColCount}px)`, verticalAlign: 'top', marginBottom: components.length - col < i+1 ? 0 : 5,}
      
      // // Return add button
      // if (i === _components.length-1) {
      //   // console.log('index_plus_one :', index_plus_one);
      //   // console.log('index_plus_one % col === 0 :', index_plus_one % col === 0);
      //   // console.log('index_plus_one !== 0 :', index_plus_one !== 0);
      //   // console.log('index_plus_one+1 > col :', index_plus_one+1 > col);
      //   const preDropAreaFlag_forBtn = i % col === 0 && i !== 0 && i+1 > col
      //   console.log('preDropAreaFlag_forBtn :', preDropAreaFlag_forBtn);
      //   const add_btn_style = {
      //     ...componentWrapStyle, 
      //     minHeight: attr === 'NORMAL/BUTTON' ? 35 : 224,
      //     marginBottom: attr === 'NORMAL/BUTTON' ? 4 : 3,
      //     marginLeft: preDropAreaFlag_forBtn || fillRemainCol ? 20 : 0,
      //   }
      //   return (
      //     <div className='add-btn' style={add_btn_style} onClick={onClickAddBtn}>
      //       {/* <button className='add-btn'></button> */}
      //     </div>
      //   )
      // }
      
      // Return result of component rendering
      if (typeInspectResult.result) {
        return (
          <div style={componentWrapStyle}>
            <NormalComponentContainer {...component} 
              key={i}
              index={i}
              onDrop={onDrop}
              message_index={message_index}
              row_index={row_index}
              editing_row_index={editingRowIndex}
              component_index={i+1}
              editing_slide_page_index={editing_slide_page_index}
              isDragging={isDragging}
              inDepth={editingRowIndex || editingRowIndex === 0}
              attr={typeInspectResult.type}
              horizontalDropArea={true}
              preDropArea={preDropAreaFlag}
              renderType={'grid'}
              col={col}
              disable={editing && !editingThis}
              messageActions={messageActions}
            />
          </div>
        )
      }
      return (
        <p> Grid system is Not support for Special components </p>
        // <SpecialComponentContainer {...component}
        //   key={local_id}
        //   index={i}
        //   onDrop={onDrop}
        //   message_index={message_index}
        //   row_index={row_index}
        //   editing_row_index={editing_row_index}
        //   component_index={i+1}
        //   attr={typeInspectResult.type}
        // />
      )
    }))

    return render_result
  }

  // Allow only Button, Image
  const optionRenderFlag = (
    attr === "NORMAL/"+DnD_element_type.COMPONENT.NORMAL.BUTTON.inDepth || attr === "NORMAL/"+DnD_element_type.COMPONENT.NORMAL.BUTTON.outDepth ||
    attr === "NORMAL/"+DnD_element_type.COMPONENT.NORMAL.IMAGE.inDepth || attr === "NORMAL/"+DnD_element_type.COMPONENT.NORMAL.IMAGE.outDepth
  )
  const optionHeaderClassname = classnames('row-option-header', {
    'on': _showOptions,
  })
  const rowClassname = classnames('message-row', {
    'option': optionRenderFlag,
    'on': optionRenderFlag && _showOptions,
    'layout-slider': optionRenderFlag && layout === 'slide',
    'editing': editing,
    'blur': !editingThis,
  })

  const renderOptionCond = {
    layout: editingRowIndex === null || editingRowIndex === undefined ? true : false
  }
               
  return (
    <div className={rowClassname}>
    {/* {
      editing && !editingThis && (
        <p className='disable-msg'> 슬라이드 페이지 수정 상태에서는 수정할 수 없습니다. </p>
      )
    } */}
    {
      optionRenderFlag && (
        <div className={optionHeaderClassname}>
          {
            !_showOptions && (
              <div className='show-opt-btn' onClick={(e) => {setShowOptions(true)}}></div>
            )
          }
          {_showOptions && 
            <RowOptions
              layout={layout} 
              col={col}
              fillRemainCol={fillRemainCol}
              message_index={message_index} 
              row_index={row_index} 
              editing_row_index={editingRowIndex} 
              offOption={() => {setShowOptions(false)}}
              updateRow={updateRow}
              renderCond={renderOptionCond}
              layoutDialogRef={layoutDialogRef}
            />
          }
        </div>
      )
    }
    {render_Components(layout, attr, col, components, fillRemainCol, onComponentDrop_menu)}
    </div>
  )
}

const MIN_FOR_WIDTH_VALUE = 20

/**
 * Options for row
 * props
 * renderCond: {
 *   layout: <boolean>,
 *   grid: <boolean>,
 *   fillRemainCol: <boolean>, 
 * }
 */
const RowOptions = (props) => {
  const { col, fillRemainCol, layout, renderCond, layoutDialogRef } = props
  const { updateRow } = props

  let renderCondLayout, renderCondGrid, renderCondFillRemainCol
  if (renderCond) {
    renderCondLayout= renderCond.layout === false ? false : true
    renderCondGrid= renderCond.grid === false ? false : true
    renderCondFillRemainCol= renderCond.fillRemainCol === false ? false : true
    // renderCondLayout= (renderCond.layout === undefined || renderCond.layout === null) ? true : renderCond.layout === false ? false : true
    // renderCondGrid= (renderCond.grid === undefined || renderCond.grid === null) ? true : renderCond.grid === false ? false : true
    // renderCondFillRemainCol= (renderCond.fillRemainCol === undefined || renderCond.fillRemainCol === null) ? true : renderCond.fillRemainCol === false ? false : true
  }

  const [ layoutEditState, setLayoutEditState ] = useState(false)
  let displayNoneTimer = null
  const [ displayNoneFlag, setDisplayNoneFlag ] = useState(true)
  useEffect(() => {
    if (!layoutEditState) {
      displayNoneTimer = setTimeout(() => {
        console.log('display none flag to ', true)
        setDisplayNoneFlag(true)
      }, 250)
    } 
  }, [layoutEditState])
  useEffect(() => {
    if (!displayNoneFlag) {
      setLayoutEditState(true)
    } 
  }, [displayNoneFlag])

  const onClickBlankArea = (e) => {
    const { offOption } = props
    offOption()
  }

  const onColChange = (e) => {
    const { target } = e
    let { value } = target
    try {
      value = parseInt(value)
    } catch (e) {
      console.error('Failed to parse for col value ', e)
      console.info('value :', value)
      return 
    }
    updateRow({
      col: value
    })
  }

  const onLayoutChange = (e) => {
    const { target } = e
    const { dataset } = target
    let { layout } = dataset

    updateRow({
      layout: layout
    })
  }

  const onFillRemainColChange = (e) => {
    const { target } = e
    const { checked } = target

    updateRow({
      fillRemainCol: checked
    })
  }

  const onClickLayout = (e) => {
    // show -> hide
    if (layoutEditState) {
      // setDisplayNoneFlag()
      setLayoutEditState(false)
    } else { // hide -> show
      setDisplayNoneFlag(false)
      // setLayoutEditState(true)
    }
    e.stopPropagation()
  }

  const layoutSelBoxClassname = classnames('layout-select-modal', {
    'show': layoutEditState,
    'hide': displayNoneFlag,
  })
  const layoutBoxClassname = classnames('layout-box', {
    // 'collapse': layoutEditState,
  })

  return (
    <div className='options' onClick={onClickBlankArea}>
      {
        renderCondLayout && (
          <React.Fragment>
            <span className={layoutBoxClassname} onClick={onClickLayout}> 
              {translateLayout(layout)}
            </span>
            <div className={layoutSelBoxClassname} ref={layoutDialogRef}>
              <p className='title'> 레이아웃 선택 </p>
              <ul className='layout-select-box'>
                <li data-layout="default" className="layout-con" onClick={onLayoutChange}> {translateLayout('default')} </li> 
                <li data-layout="slide" className="layout-con" onClick={onLayoutChange}> {translateLayout('slide')} </li> 
              </ul>
            </div>
          </React.Fragment>
        )
      }
      {
        renderCondGrid && (
          <select name='col' onClick={(e) => {e.stopPropagation()}} onChange={onColChange} >
            <option value="1" selected={1 === col}> 1 </option>
            <option value="2" selected={2 === col}> 2 </option>
            <option value="3" selected={3 === col}> 3 </option>
          </select>
        )
      }
      {
        renderCondFillRemainCol && (
          <React.Fragment>
            <span title={getWording('FILL_REMAIN_COL_TITLE')}> 남은 컬럼 채우기 </span> 
            <input id={`row-opt-fill-${props.message_index}-${props.row_index}${props.editingRowIndex ? '-'+props.editingRowIndex : ''}`} type='checkbox' className='default-checkbox'
              checked={fillRemainCol}
              onClick={(e) => {e.stopPropagation()}} 
              onChange={onFillRemainColChange} />
            <label htmlFor={`row-opt-fill-${props.message_index}-${props.row_index}${props.editingRowIndex ? '-'+props.editingRowIndex : ''}`} onClick={(e) => {e.stopPropagation()}} ></label>
          </React.Fragment>
        )
      }
      {
        col > 1 && layout !== 'default' && (
          <span className='help-comment' title='레이아웃과 그리드를 동시에 적용했을 경우 레이아웃이 먼저 적용됩니다.' onClick={(e) => {e.stopPropagation()}}>?</span>
        )
      }
    </div>
  )
}

const DraggableComponentWrap = (props) => {
  return props.noDrag ? (
    props.children
  ) : (
    <DnDContext>
      <DraggableComponent dragHandle={DragHandle(props.disable)} disableDrag={props.disable} {...props}>
        {props.children}
      </DraggableComponent>
    </DnDContext>
  )
}

const isNormalComponent = (attr) => {
  const slicedAttr = attr.split('/')
  if (slicedAttr) {
    if (slicedAttr[0]) {
      if (slicedAttr[0] === "NORMAL") {
        return {
          result : true,
          prefix : slicedAttr[0],
          type : slicedAttr[1]
        }
      }
      return { 
        result : false,
        prefix : slicedAttr[0],
        type : slicedAttr[1]
      }
    }
  }
}

const overContentArg = {
  minHeight: 15,
  opacity: 0.3,
}
const overContentArg_grid = {
  minHeight: 35,
  opacity: 0.3,
}

export default Row